// ----------------------------------------------------------------------
export var Radio = function Radio() {
  return {
    MuiRadio: {
      defaultProps: {
        color: 'primary'
      },
      styleOverrides: {
        root: {
          padding: 8
        }
      }
    }
  };
};